export default "__VITE_ASSET__1e48d164__"